import { makeStyles, Theme } from "@material-ui/core/styles";
import React, { useContext } from "react";
import GenericPermissionContext from "../../contexts/GenericPermissionContext";
import CustomFooterGraphic from "../Requests/CustomFooterGraphic";
import AdminUserOverview from "./AdminUserOverview/AdminUserOverview";
import CountryListUpload from "./CountryListUpload";
import ExchangeRateUpload from "./ExchangeRateUpload";
import UserAssignmentUpload from "./UserAssignmentUpload";

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    fontFamily: "Proxima Nova",
    margin: theme.spacing(3),
  },
}));

interface AdminSettingsProps {}

const AdminSettings: React.FC<AdminSettingsProps> = () => {
  const classes = useStyles();
  const { viewUserTable } = useContext(GenericPermissionContext);
  // disable features via ticket 36883, might delete later
  const showUserAssignmentUpload = false;
  const showCountryListUpload = false;

  return (
    <div className={classes.root}>
      <h2>Administration Area </h2>
      {showUserAssignmentUpload && <UserAssignmentUpload />}
      {showCountryListUpload && <CountryListUpload />}
      <ExchangeRateUpload />
      {viewUserTable && <AdminUserOverview />}
      <CustomFooterGraphic />
    </div>
  );
};

export default AdminSettings;
